export const NAV = {
        logoLink: "nav-logo-link",
        archiveLink: "nav-archive-link",
        adminLink: "nav-admin-link",
        aboutLink: "nav-about-link",
};

export const TOPIC = {
        card: (slug) => `topic-card-${slug}`,
        cardTitle: (slug) => `topic-card-title-${slug}`,
        detailTitle: "topic-detail-title",
        detailCategory: "topic-detail-category",
        factsList: "topic-detail-facts",
        narrativesList: "topic-detail-narratives",
        deceptionBlock: "topic-detail-deception",
        aiAnalysisBlock: "topic-detail-ai-analysis",
        sourcesList: "topic-detail-sources",
        backLink: "topic-detail-back",
};

export const FILTER = {
        category: (slug) => `filter-category-${slug}`,
        categoryAll: "filter-category-all",
};

export const ADMIN = {
        loginInput: "admin-login-input",
        loginSubmit: "admin-login-submit",
        loginError: "admin-login-error",
        logoutBtn: "admin-logout-btn",
        newTopicBtn: "admin-new-topic-btn",
        generateBtn: "admin-generate-btn",
        providerSelect: "admin-provider-select",
        titleInput: "admin-title-input",
        categorySelect: "admin-category-select",
        hintInput: "admin-hint-input",
        saveBtn: "admin-save-btn",
        deleteBtn: (id) => `admin-delete-${id}`,
        editBtn: (id) => `admin-edit-${id}`,
        topicListItem: (id) => `admin-topic-${id}`,
};
